import { nsPartners } from '@/app/i18n/namespaces';

export default {
    UUID: {
        key: 'uuid',
        type: 'text',
        entity: 'keys.uuid',
        namespace: nsPartners,
        placeholder: 'filter.placeholder.uuid',
        filter: 'input',
        enableSorting: false
    },
    LEGAL_NAME: {
        key: 'legalName',
        type: 'text',
        entity: 'keys.legal_name',
        namespace: nsPartners,
        placeholder: 'filter.placeholder.legal_name',
        filter: 'input',
        enableSorting: true
    },
    CONNECTION_POINTS: {
        key: 'connectionPoints',
        type: 'array',
        entity: 'keys.ports',
        namespace: nsPartners,
        placeholder: 'filter.placeholder.ports',
        filter: 'input',
        enableSorting: true,
        PORTS: {
            parentKeys: ['connectionPoints'],
            key: 'port',
            type: 'text'
        }
    },
    REGISTRATION_NUMBER: {
        key: 'registrationNumber',
        type: 'text',
        entity: 'keys.registration_number',
        namespace: nsPartners,
        placeholder: 'filter.placeholder.registration_number',
        filter: 'input',
        enableSorting: true
    }
};